import AUPPSRDetails from "modules/new-applications/components/application-actions/PPSRRegister/PPSRDetails/AUPPSRDetails";
import NZPPSRDetails from "modules/new-applications/components/application-actions/PPSRRegister/PPSRDetails/NZPPSRDetail";

export { AUPPSRDetails };
export { NZPPSRDetails };
